import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

const BackendIndexPage = () => {
    return (
        <div className="d-flex align-items-center justify-content-center h-100">
            <img src={`${process.env.PUBLIC_URL}/assets/undraws/undraw_spreadsheet_re_cn18.svg`} style={{ maxWidth: "100%" }} />
        </div>
    );
};

export default BackendIndexPage;
